<template>
  <main id="container" class="page-container page-category bg-wave2">
    <div class="page-header">
      <div class="container">
        <div class="display-flex is-between">
          <page-header title="소상공인과 함께하는 2026 동행축제" />
          <span class="txt-total">총 <b>{{ totalCount }}개</b></span>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="container">
        <!-- <div class="category-search">
          <h2 class="category-search-title">제품검색</h2>
          <div class="category-search-area">
            <input
              type="text"
              class="category-search-input"
              v-model="searchName"
              placeholder="제품명을 입력하세요."
              @keyup.enter="searchManprdList('')"
            />
            <button
              class="category-search-button"
              @click="searchManprdList('')"
            >
              <i class="icon">
                <img src="@/assets/img/category/search_icon.svg" alt="검색" />
              </i>
            </button>
          </div>
        </div> -->
        <!-- <div class="category-items">
           <ul class="category-items-list">
            <li
              class="category-items-list-li"
              v-for="item in ctgrItems"
              :key="item.dcd"
            >
              <button
                type="button"
                :class="
                  item.dcd == ctgrDcd
                    ? 'category-item is-active'
                    : 'category-item'
                "
                @click="searchManprdList(item.dcd)"
              >
                <div class="category-item is-active">
                <div class="category-item-img">
                  <i class="icon">
                    <img
                      :src="require(`@/assets/img/category/${item.img}`)"
                      alt=""
                    />
                  </i>
                </div>
                <span class="item-title">{{ item.dcdVal }}</span>
              </button>
            </li>
          </ul> -->
          <!-- <ul class="category-items-list" v-if="ctgrDcd !== ''">
            <li
              class="category-items-list-li"
              v-for="item in selectCodeList"
              :key="item.dcd"
            >
              <button
                type="button"
                :class="
                  item.subCtgrDcd == subCtgrDcd
                    ? 'category-item is-active'
                    : 'category-item'
                "
                @click="searchManprdSubList(item.subCtgrDcd)"
              >
                <span class="item-title">{{ item.subCtgrNm }}</span>
              </button>
            </li>
          </ul>
        </div> -->
        <!--
          <div class="placeholder-div-right20">
            
            <div class="sort-options display-flex is-right mb-20">
              <button
                type="button"
                :class="['button', 'button-sm', { 'is-active': sortCd === 'F' }]"
                @click="setSortOrder('F')"
              >
                추천순
              </button>
              <button
                v-if="sortCd == '' || sortCd == 'F'"
                type="button"
                class="button button-sm"
                @click="setSortOrder('PU')"
              >
                가격순
              </button>

              <button
                v-if="sortCd == 'PD'"
                type="button"
                :class="['button', 'button-sm', { 'is-active': sortCd === 'PD' }]"
                @click="setSortOrder('')"
              >
                가격순↓
              </button>

              현재 정렬이 'PU'(가격 오름차순)일 때 '가격순↓' 버튼 표시
              <button
                v-if="sortCd == 'PU'"
                type="button"
                :class="['button', 'button-sm', { 'is-active': sortCd === 'PU' }]"
                @click="setSortOrder('PD')"
              >
                가격순↑
              </button>
            </div>
          </div>
        -->
        <div class="products-list" :class="{ 'has-banner': bannerImage }">
          <div class="category-title-box" v-if="bannerImage">
            <img :src="bannerImage" alt="Category Banner">
          </div>
          <products-item
            v-for="(item, idx) in manprdList"
            :key="item.manprdId"
            :id="item.id"
            :item="item"
            type=""
            :evnt-strt-dt="evntStrtDt"
            :evnt-end-dt="evntEndDt"
            parent-like-evnt-nm="likeClicked"
            @likeClicked="handleClickLike"
            parent-click-evnt-nm="modalClicked"
            @modalClicked="handleClickModal"
          />
        </div>
        
        <div class="btn-more-cont-wrap" v-if="manprdList.length < totalCount">
          <button type="button" class="btn-more-cont" @click="loadMore">
            <span>상품 더보기 ({{ manprdList.length }}/{{ totalCount }})</span>
          </button>
        </div>
        <!-- <div class="btn-more-cont-wrap" v-else-if="manprdList.length > initialPageSize">
          <button type="button" class="btn-more-cont" @click="loadLess">
            <span>상품 접기</span>
          </button>
        </div> -->
      </div>
    </div>
    <products-modal
      :visible="visibleModal"
      @closeModal="handleCloseModal"
      :item="modalItem"
      :evnt-strt-dt="evntStrtDt"
      :evnt-end-dt="evntEndDt"
      parent-click-evnt-nm="clickEvnt"
      @clickEvnt="handleClickModalEvnt"
    />
    <!-- <div class="pagination-wrap">
      <portal-pagination
        page-name="Category"
        :page-no="pageNo"
        :page-size="pageSize"
        :page-list-size="pageListSize"
        :total-count="totalCount"
        :query="queries"
        :parent-method-name="pagingMethodName"
        @getManprdList="getManprdList"
      ></portal-pagination>
    </div> -->
  </main>
</template>
<style>
/* .products-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}


.category-banner-item {
  flex: 0 0 calc(33.333% - 12px);
  box-sizing: border-box;
}
.category-banner-item img {
  width: 100%;
  display: block;
}

.products-list.has-banner > .products-item {
  flex: 0 1 calc(16.666% - 17px);
}

@media (max-width: 1160px) {
  .category-banner-item {
    flex: 0 0 calc(40% - 10px);
  }
  .products-list.has-banner > .products-item {
    flex: 0 1 calc(20% - 17px);
  }
}

@media (max-width: 767px) {
  .products-list.has-banner {
    gap: 24px 10px;
  }
  .category-banner-item {
    flex: 0 0 100%;
    margin-bottom: 6px;
  }
  .products-list.has-banner > .products-item {
    flex: 0 1 calc(50% - 5px);
  }
}

.placeholder-div-right20 {
  width: 20%;
  margin-left: auto;
}
.sort-options {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-bottom: 15px;
}
.sort-options .button {
  padding: 3px 10px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  cursor: pointer;
  border-radius: 3px;
  font-size: 12px;
  line-height: 1.4;
  transition: background-color 0.2s, border-color 0.2s;
}
.sort-options .button:hover {
  background-color: #eee;
}
.sort-options .button.is-active {
  background-color: #e0e0e0;
  border-color: #aaa;
  font-weight: bold;
}
.display-flex {
  display: flex;
}
.is-right {
  justify-content: flex-end;
}
.mb-20 {
  margin-bottom: 20px;
} */
</style> 
<script>
import { mapGetters } from "vuex";
import {
  ACT_GET_COMMON_CODE_LIST,
  ACT_GET_CAMPN_MANPRD_LIST,
  ACT_UPDATE_CAMPN_MANPRD_FAVR,
  ACT_UPDATE_CAMPN_MANPRD_STAR,
  ACT_GET_DHFESTA_EVENT_MNG,
  ACT_GET_SUB_CTGR_CODE_LIST,
} from "@/store/_act_consts";
import {
  MUT_SET_RETURN_ROUTE,
  MUT_SHOW_CONFIRM,
  MUT_SHOW_ALERT,
} from "@/store/_mut_consts";

import {
  getItem,
  getItems,
  lengthCheck,
  getCheckItems,
  setPaging,
  tryResCallback,
  queryToValue,
  isSuccess,
  timestampToDateFormat,
} from "@/assets/js/utils";

import PortalPagination from "@/components/PortalPaginationRoute";
import PageHeader from "@/components/content/PageHeader";
import ProductsModal from "@/components/content/ProductsModal";
import ProductsItem from "@/components/content/ProductsItem";
export default {
  name: "Category",
  components: { PortalPagination, PageHeader, ProductsItem, ProductsModal },
  data: () => ({
    pagingMethodName: "getManprdList",
    pageNo: 1,
    pageSize: 22,
    initialPageSize: 22,
    loadMoreSize: 12,
    pageListSize: 10,
    totalCount: 0,
    searchName: "",
    visibleModal: false,
    ctgrDcd: "",
    subCtgrDcd: "",
    ctgrItems: [],
    modalId: 0,
    modalType: "",
    manprdList: [],
    manprdAllList: [],
    manprdFilterList: [],
    originalFilteredList: [],
    evntStrtDt: "",
    evntEndDt: "",
    sortCd: "",
    favrCnt: 0,
    manprdPrc: 0,
    subCodeList: {},
    selectCodeList: {},
  }),
  computed: {
    ...mapGetters("common", ["isMobile", "commonCode", "campn"]),
    ...mapGetters("auth", ["session", "isAuth"]),
    campnId() {
      return this.campn.campnId;
    },
    modalItem() {
      if (this.modalId > 0)
        return this.manprdAllList.find((i) => i.id == this.modalId);

      return null;
    },
    queries() {
      const result = {};
      result.searchName = this.searchName;
      result.ctgrDcd = this.ctgrDcd;
      return result;
    },
    bannerImage() {
      switch (this.ctgrDcd) {
        case '1501001': // 뷰티
          return require('@/assets/img/main/category-title01.png');
        case '1501002': // 생활
        case '1501008': // 생활/가전
          return require('@/assets/img/main/category-title02-PC.png');
        case '1501003': // 식품
          return require('@/assets/img/main/category-title03.png');
        case '1501007': // 패션/잡화 (디지털상품관)
          return require('@/assets/img/main/category-title04.png');
        default:
          return null;
      }
    },
  },
  watch: {},
  async created() {
    if (this.isMobile) this.pageListSize = 5;
    // this.ctgrDcd = this.$route.params.ctgrDcd;
    this.ctgrDcd = queryToValue(this.$route.query.ctgrDcd, false, "");
    this.getCtgrList();
    this.getManprdAllList();
    this.getEvntMng();
    this.getSubCtgrList();
  },
  mounted() {},
  methods: {
    // 팝업 max-height
    setLayerHeight() {
      const layer = document.querySelector('.layer-popup-container');
      if (!layer) return;

      const inner = layer.querySelector('.layer-popup');
      if (!inner) return;

      const style = getComputedStyle(inner);
      const pdt = parseFloat(style.paddingTop) || 0;
      const pdb = parseFloat(style.paddingBottom) || 0;

      const footer = layer.querySelector('.popup-footer');
      const header = inner.querySelector('.popup-header');

      const bottomFixedHeight = footer ? footer.offsetHeight : 0;
      const headerHeight = header ? header.offsetHeight : 0;

      const popupBody = inner.querySelector('.popup-body');
      if (!popupBody) return;

      const maxHeight =
        window.innerWidth > 800
          ? layer.offsetHeight * 0.7 - (pdt + pdb) - bottomFixedHeight - headerHeight
          : layer.offsetHeight * 0.9 - (pdt + pdb) - bottomFixedHeight - headerHeight;

      popupBody.style.maxHeight = `${maxHeight}px`;
    },
    // 팝업 max-height 리사이즈
		setResizeEvent() {
			window.removeEventListener("resize", this.resizeHandler);

			this.resizeHandler = () => {
				this.setLayerHeight();
			};

			window.addEventListener("resize", this.resizeHandler);

			this.setLayerHeight();
		},
    async getCtgrList() {
      this.$store
        .dispatch(`common/${ACT_GET_COMMON_CODE_LIST}`, {
          dcd: "1501",
          masterYn: "N",
        })
        .then((res) => {
          if (lengthCheck(res)) {
            const items = getItems(res).map((i) => {
              let item = {};
              switch (i.dcd) {
                case "1501001":
                  item = { ...i, img: "list_item02.png", title: "뷰티" };
                  break;
                case "1501002":
                  item = { ...i, img: "list_item03.png", title: "생활" };
                  break;
                case "1501003":
                  item = { ...i, img: "list_item04.png", title: "식품" };
                  break;
                case "1501004":
                  item = { ...i, img: "list_item05.png", title: "전자기기" };
                  break;
                case "1501005":
                  item = { ...i, img: "list_item06.png", title: "가구·조명" };
                  break;
                case "1501006":
                  item = { ...i, img: "list_item07.png", title: "주방" };
                  break;
                case "1501007":
                  item = { ...i, img: "list_item08.png", title: "패션·잡화" };
                  break;
                case "1501008":
                  item = { ...i, img: "list_item09.png", title: "가전/기타" };
                  break;
                default:
                  break;
              }

              return item;
            });

            this.ctgrItems = this.ctgrItems.concat(
              {
                dcd: "",
                dcdVal: "전체",
                img: "list_item01.png",
                title: "전체",
              },
              items
            );
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    async getSubCtgrList() {
      this.$store
        .dispatch(`manprd/${ACT_GET_SUB_CTGR_CODE_LIST}`)
        .then((res) => {
          if (lengthCheck(res)) {
            // 1. API로부터 하위 카테고리 목록 추출
            const subCategories = getItems(res);

            // 2. "전체" 카테고리 객체 생성
            const allCategory = {
              subCtgrDcd: "",
              subCtgrNm: "전체",
            };

            //    (옵션 2: 스프레드 문법 사용 - 더 선호됨)
            this.subCodeList = [allCategory, ...subCategories];
          } else {
            // 데이터가 없는 경우 "전체"만 포함하거나 빈 배열로 설정
            // 요구사항에 따라 "전체"만 보여줄 수도 있습니다.
            this.subCodeList = [{ subCtgrDcd: "", subCtgrNm: "전체" }];
            // 또는 완전히 비우려면: this.subCodeList = [];
          }
        })
        .catch((e) => {
          console.error("하위 카테고리 목록 로드 실패:", e);
          this.subCodeList = []; // 오류 시 빈 배열로 초기화
        });
    },
    getManprdAllList() {
      this.pageNo = 1;
      this.manprdList = [];

      // api 호출
      this.$store
        .dispatch(`manprd/${ACT_GET_CAMPN_MANPRD_LIST}`, {
          campnId: this.campnId,
          manprdNm: "",
          ctgrDcd: "",
          sortCd: "",
          pageNo: 1,
          pageSize: 1000,
        })
        .then((res) => {
          tryResCallback(
            this.tryCount,
            res,
            this.getManprdAllList,
            this.setManprdAllList
          );
        })
        .catch((e) => {
          console.error(e);
        });
    },
    setManprdAllList(res) {
      if (lengthCheck(res)) {
        this.manprdFilterList = this.manprdAllList = getCheckItems(res).map(
          (i) => {
            return {
              id: i.manprdId,
              image: i.manprdImgFileUrl,
              company: i.brndNm,
              title: i.manprdNm,
              price: i.manprdPrc,
              rate: i.socreAvg,
              rateCount: i.scoreCnt,
              like: i.favrYn == "Y",
              likeCount: i.favrCnt,
              myRate: i.myScore,
              desc: i.manprdDesc,
              siteUrl: i.ntslSiteUrl,
              reviewUrl: i.reviewUrl,
              saleYn: i.saleYn,
              isEng: false,
              useCampnDurYn: i.useCampnDurYn == "Y",
              ntslStrtDt: timestampToDateFormat(i.ntslStrtDt, "yyyy-MM-dd"),
              ntslEndDt: timestampToDateFormat(i.ntslEndDt, "yyyy-MM-dd"),
              ctgrDcd: i.ctgrDcd,
              subCtgrDcd: i.subCtgrDcd,
              manprdComp: i.manprdComp,
            };
          }
        );
        this.totalCount = res.paging.totalCount;
        this.searchManprdList(this.ctgrDcd);
      }

      //setPaging(this, res);
    },
    getManprdList(pageNo, isAppend = false) {
      this.pageNo = pageNo;
    this.manprdList = this.manprdFilterList.slice(0, this.pageSize);
    },
    loadMore() {
      this.pageSize += this.loadMoreSize;
      const expanded = this.manprdFilterList.slice(0, this.pageSize);
      this.manprdList = expanded;
    },
    // loadLess() {
    //   const newSize = Math.max(this.pageSize - this.loadMoreSize, this.initialPageSize);
    //   this.pageSize = newSize;
    //   this.manprdList = this.manprdFilterList.slice(0, this.pageSize);
    // },
    searchManprdList(dcd) {
      this.ctgrDcd = dcd;
      let searchManprdList = [];

      if (this.searchName) {
        searchManprdList = this.manprdAllList.filter(
          (m) => m.title.indexOf(this.searchName) > -1
        );
      } else {
        searchManprdList = this.manprdAllList;
      }

      if (this.ctgrDcd)
        this.manprdFilterList = searchManprdList.filter(
          (m) => m.ctgrDcd == this.ctgrDcd
        );
      else this.manprdFilterList = searchManprdList;

      // 필터링된 결과를 정렬 전 원본 목록으로 저장
      this.originalFilteredList = [...this.manprdFilterList];

      this.totalCount = this.manprdFilterList.length;
      this.getManprdList(1);
      this.subCtgrDcd = "";

      // 5. 선택된 상위 카테고리에 해당하는 하위 카테고리 목록 필터링
      // 주의: 이 로직은 subCodeList의 각 항목에 해당 하위 카테고리의 부모 카테고리 코드인 'ctgrDcd' 속성이 포함되어 있다고 가정합니다.
      // 만약 subCodeList에 'ctgrDcd'가 없다면, API 응답을 수정하거나 다른 방식으로 하위 카테고리를 필터링해야 합니다.
      if (this.ctgrDcd) {
        // '전체'가 아닌 특정 상위 카테고리가 선택된 경우
        // 전체 하위 카테고리 목록(subCodeList)에서
        // 현재 선택된 상위 카테고리 코드(this.ctgrDcd)와 일치하는 ctgrDcd를 가진 하위 카테고리만 필터링
        const filteredSubCategories = this.subCodeList.filter(
          (sub) => sub.ctgrDcd == this.ctgrDcd
        );

        if (!filteredSubCategories || filteredSubCategories.length === 0) {
          // 필터링된 하위 카테고리가 없다면
          this.ctgrDcd = "";
          //this.selectCodeList = {};
        }

        // 필터링된 하위 카테고리 목록 앞에 '전체' 옵션을 추가하여 selectCodeList에 저장
        this.selectCodeList = [
          { subCtgrDcd: "", subCtgrNm: "전체" }, // 하위 카테고리용 '전체' 옵션
          ...filteredSubCategories, // 필터링된 하위 카테고리 목록
        ];
      } else {
        // 상위 카테고리로 '전체'가 선택된 경우, 하위 카테고리 목록은 보여주지 않음
        // (템플릿의 v-if="ctgrDcd !== ''" 조건에 의해 자동으로 숨겨짐)
        // selectCodeList를 비워줍니다.
        this.selectCodeList = [];
      }
    },
    searchManprdSubList(dcd) {
      this.subCtgrDcd = dcd; // 선택된 하위 카테고리 코드 저장

      if (this.subCtgrDcd) {
        // --- 특정 하위 카테고리가 선택된 경우 ---
        let baseList = [];

        // 1. 검색어 필터링 (전체 목록 기준)
        if (this.searchName) {
          baseList = this.manprdAllList.filter(
            (m) => m.title.indexOf(this.searchName) > -1
          );
        } else {
          baseList = [...this.manprdAllList];
        }

        // 2. 현재 활성화된 상위 카테고리로 먼저 필터링
        const mainCategoryFiltered = this.ctgrDcd
          ? baseList.filter((m) => m.ctgrDcd == this.ctgrDcd)
          : baseList; // 상위 카테고리가 없다면 검색어 필터링 결과 사용

        // 3. 선택된 특정 하위 카테고리로 최종 필터링
        this.manprdFilterList = mainCategoryFiltered.filter(
          (m) => m.subCtgrDcd == this.subCtgrDcd
        );

        // 하위 카테고리까지 필터링된 결과를 정렬 전 원본 목록으로 저장
        this.originalFilteredList = [...this.manprdFilterList];

        // 4. 결과 업데이트
        this.totalCount = this.manprdFilterList.length;
        this.getManprdList(1);
      } else {
        // --- 하위 카테고리 '전체'가 선택된 경우 (dcd가 '') ---
        // 현재 선택된 상위 카테고리(this.ctgrDcd)와 검색어(this.searchName)를 기준으로
        // 목록을 다시 필터링하기 위해 searchManprdList 함수를 호출합니다.
        this.searchManprdList(this.ctgrDcd);
      }
    },
    setSortOrder(newSortCd) {
      // 1. 다음 정렬 상태 결정
      let targetSortCd = newSortCd;
      // '추천순' 버튼 토글: F -> ''
      if (newSortCd === "F" && this.sortCd === "F") {
        targetSortCd = "";
      }
      // '가격순↓' 버튼 클릭 시 (현재 PD 상태일 때): PD -> ''
      else if (newSortCd === "" && this.sortCd === "PD") {
        // 이 조건은 가격순↓ 버튼의 @click 핸들러가 ''를 전달할 때 필요합니다.
        // 현재 코드에서는 가격순↓ 버튼이 setSortOrder('')를 호출하므로, 이 조건이 직접적으로 필요 없을 수 있지만,
        // 명확성을 위해 남겨두거나, 버튼 클릭 로직과 맞춰 조정할 수 있습니다.
        // 만약 가격순↓ 버튼이 항상 setSortOrder('')를 호출한다면, 아래 else if (this.sortCd === '') 블록에서 처리됩니다.
        targetSortCd = "";
      }
      // 그 외의 경우는 newSortCd를 그대로 사용 (PU -> PD, '' -> F, '' -> PU 등)

      this.sortCd = targetSortCd; // 최종 정렬 상태 업데이트

      // 2. 정렬 적용 또는 해제
      if (this.sortCd === "") {
        // --- 변경된 부분 ---
        // 정렬 비활성화: 저장된 원본 필터 목록으로 복원
        this.manprdFilterList = [...this.originalFilteredList];
        // --- 변경된 부분 끝 ---
      } else {
        // --- 변경된 부분 ---
        // 정렬 활성화: 원본 필터 목록의 복사본을 정렬
        let listToSort = [...this.originalFilteredList]; // 원본을 변경하지 않기 위해 복사
        // --- 변경된 부분 끝 ---

        if (this.sortCd === "F") {
          // 추천순(F): likeCount 내림차순
          listToSort.sort((a, b) => b.likeCount - a.likeCount);
        } else if (this.sortCd === "PD") {
          // 가격순(PD): price 내림차순
          listToSort.sort((a, b) => b.price - a.price);
        } else if (this.sortCd === "PU") {
          // 가격순(PU): price 오름차순
          listToSort.sort((a, b) => a.price - b.price);
        }

        // 정렬된 목록을 manprdFilterList에 할당
        this.manprdFilterList = listToSort;
      }

      // 3. 페이지네이션 및 화면 업데이트
      // totalCount는 필터링 시 결정되므로 여기서는 변경하지 않습니다.
      this.getManprdList(1); // 정렬된 결과의 첫 페이지 표시
    },
    // 찜하기
    handleClickLike(idx, type) {
      this.getManprdAllList();
      // const item = this.manprdList.find(i => i.id == idx);
      // this.setFavr(item);
    },
    handleClickModal(idx, type) {
      this.modalId = idx;
      this.visibleModal = true;

      this.layerScrollTop = window.scrollY;
      // 모바일 크롬에서 body에 스크롤 생기는 이슈 해결
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.layerScrollTop}px`;
        document.body.style.width = '100%';

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const header = document.querySelector('.header');
            if (header && this.layerScrollTop > 0) {
              header.classList.add('hd-bg');
            }
            this.setResizeEvent();
          });
        });
    },
    handleCloseModal() {
      this.visibleModal = false;

      // 모바일 크롬에서 body에 overflow
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

      // DOM 렌더 후 스크롤 복구
      this.$nextTick(() => {
        window.scrollTo(0, this.layerScrollTop);
        window.removeEventListener("resize", this.resizeHandler);
      });
    },
    handleClickModalEvnt(type, score) {
      this.getManprdAllList();
      // if(type == "F") this.setFavr(this.modalItem);
      // else this.setStar({ ...this.modalItem, myRate: score});
    },
    async getEvntMng() {
      this.evntStrtDt = "";
      this.evntEndDt = "";

      await this.$store
        .dispatch(`event/${ACT_GET_DHFESTA_EVENT_MNG}`, {
          campnId: this.campn.campnId,
          evntTyp: "20",
        })
        .then((res) => {
          if (lengthCheck(res)) {
            const item = getItem(res);
            this.evntStrtDt =
              timestampToDateFormat(Number(item.evntStrtDt), "yyyy-MM-dd") +
              " 00:00";
            this.evntEndDt =
              timestampToDateFormat(Number(item.evntEndDt), "yyyy-MM-dd") +
              " 00:00";
          } else {
            this.evntStrtDt = this.campn.strtDt;
            this.evntEndDt = this.campn.endDt;
          }
        });
    },
  },
};
</script>
